import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companies: [],
  branches: [],
  validateResult: null,
  isValidating: false,
  isMoving: false,
};

const slice = createSlice({
  name: "managementSn",
  initialState,
  reducers: {
    setCompanies(state, action) { state.companies = action.payload || []; },
    setBranches(state, action) { state.branches = action.payload || []; },
    clearBranches(state) { state.branches = []; },
    setValidating(state, action) { state.isValidating = action.payload; },
    setValidateResult(state, action) { state.validateResult = action.payload; },
    clearValidateResult(state) { state.validateResult = null; },
    setMoving(state, action) { state.isMoving = action.payload; },
  },
});

export const {
  setCompanies,
  setBranches,
  clearBranches,
  setValidating,
  setValidateResult,
  clearValidateResult,
  setMoving,
} = slice.actions;

export default slice.reducer;
